import client from '@common/utils/rest';
import { NEW_PEDIGREE_ACTION_TYPES } from '../const/pedigree';
import { executeUI } from '@common/utils/ui-bridge';
import { I18n } from 'react-redux-i18n';

const PEDIGREE_URL_PREFIX = 'api/pedigree';
const QUESTIONNAIRE_URL_PREFIX = 'api/questionnaire';

const setFolders = payload => {
    return {
        type: NEW_PEDIGREE_ACTION_TYPES.getFolders,
        payload
    };
};

export const getFolders = () => dispatch => {
    return client({
        path: `${PEDIGREE_URL_PREFIX}/loadPedigreeFolders`,
        method: 'GET'
    }).then(
        response => {
            dispatch(setFolders(response.entity));
        },
    );
};

const setQuestionnaires = payload => {
    return {
        type: NEW_PEDIGREE_ACTION_TYPES.getQuestionnaires,
        payload
    };
};

export const getQuestionnaires = () => dispatch => {
    return client({
        params: {
            includeFamilyQuestionnaires: true,
            includeFhq4Questionnaires : true
        },
        path: `${QUESTIONNAIRE_URL_PREFIX}/getQuestionnaires`,
        method: 'GET'
    }).then(
        response => {
            dispatch(setQuestionnaires(response.entity));
        },
    );
}

export const launchQuestionnaire = (id, fhq, data, handleSaveClose) => {
    return client({
        params: {
            questionnaireId : parseInt(id),
            isFHQ4: fhq
        },
        path: `${QUESTIONNAIRE_URL_PREFIX}/launchNewQuestionnaire`,
        method: 'POST',
        entity: data
    }).then(
        response => {
            handleSaveClose(null);
            window.location.assign(response.entity);
        },
    ).catch(err => {
        console.log(err);
        handleSaveClose(err.entity);
    });
}

export const checkPedigreeName = (id, pedigreeName) => {
    return client({
        params: {
            folderId: parseInt(id),
            pedigreeName: pedigreeName
        },
        path: `${PEDIGREE_URL_PREFIX}/checkPedigreeNameExists`,
        method: 'GET'
    }).then(
        (response) => {
            return response.entity;
        }
    ).catch(err => {
            throw err;
        }
    )
}

export const savePedigree = (data, handleSaveClose) => dispatch => {
    client({
        path: `${PEDIGREE_URL_PREFIX}/createPedigreeFromBasicWorkflow`,
        method: 'POST',
        entity: data
    })
        .then(res => {
            handleSaveClose(null);
            executeUI('PEDIGREE','',res.entity,'');
        })
        .catch(err => {
            console.log(err);
            handleSaveClose(err.entity);
        }
    )
}